"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_router_dom_1 = require("react-router-dom");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var LogOut = function (_a) {
  var onClick = _a.onClick,
      className = _a.className,
      testId = _a.testId;
  return (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({
    className: "logout",
    "aria-label": "Logout",
    "data-testid": testId,
    onClick: onClick,
    to: "/"
  }, {
    children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
      name: "logout",
      className: className,
      width: "24"
    }, void 0)
  }), void 0);
};

LogOut.propTypes = {
  onClick: prop_types_1.func.isRequired,
  testId: prop_types_1.string.isRequired
};
exports.default = LogOut;